import type { App, InjectionKey } from "vue";
import type { Router } from "vue-router";

export type EnableAnalytics = () => Promise<void>;

export const enableAnalyticsKey = Symbol(
  "enableAnalytics",
) as InjectionKey<EnableAnalytics>;

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

export function createAnalyticsEnabler(app: App, router: Router): EnableAnalytics {
  let installPromise: Promise<void> | undefined;

  return () => {
    if (!GA_MEASUREMENT_ID) {
      return Promise.resolve();
    }

    installPromise ??= import("vue-gtag").then(
      async ({ addGtag, consentGrantedAll, createGtag }) => {
        app.use(
          createGtag({
            tagId: GA_MEASUREMENT_ID,
            initMode: "manual",
            consentMode: "denied",
            pageTracker: { router },
          }),
        );

        await addGtag();
        consentGrantedAll("update");
      },
    );

    return installPromise;
  };
}
